import { useTranslation } from 'react-i18next';

import { CourseAdminCard } from '@/components/shared/CourseAdminCard';
import { useConfirm } from '@/data/context/ConfirmModalContext';

type MaterialMoreActionsProps = {
  onDelete: () => void | Promise<unknown>;
  isLimitedEdition?: boolean;
};

export default function MaterialMoreActions({
  onDelete,
  isLimitedEdition = false,
}: MaterialMoreActionsProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.materialsTab.card',
  });
  const confirm = useConfirm();

  const handleDelete = () =>
    confirm({
      onConfirm: onDelete,
      title: t('deleteConfirmTitle'),
      description: t('deleteConfirmDescription'),
    });

  return (
    <CourseAdminCard.MoreActions>
      <CourseAdminCard.MoreActions.Delete
        onClick={handleDelete}
        disabled={isLimitedEdition}
      />
    </CourseAdminCard.MoreActions>
  );
}
